export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const appRegion = config.public.appRegion;
  const appEnv = config.public.appEnvironment;
  const gtmId = config.public.gtmId;

  if (appEnv === "local") return;

  if (appRegion === "NL") {
  let scriptContent = "";
  let noscriptSrc = "";

  if (appEnv === "staging" || appEnv === "pre-prod") {
    scriptContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s);j.async=true;j.src="https://load.sst.pre-prod.nl.toolstation.dev/eeayqbogf.js?"+i;
      f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer',
      '4dt6a=aWQ9R1RNLU1HM1hOOUta&eagGee=ecEOei');`;
    noscriptSrc = `https://load.sst.pre-prod.nl.toolstation.dev/ns.html?id=${gtmId}`;
  } else if (appEnv === "production") {
    scriptContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s);j.async=true;j.src="https://load.sst.toolstation.nl/eeayqbogf.js?"+i;
      f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer',
      '4dt6a=aWQ9R1RNLU1HM1hOOUta&eagGee=ecEOei');`;
    noscriptSrc = `https://load.sst.toolstation.nl/ns.html?id=${gtmId}`;
  } else {
    return;
  }

  useHead({
    script: [
      {
        innerHTML: scriptContent,
        tagPriority: "high",
        type: "text/javascript",
      },
    ],
  });

  if (import.meta.client) {
    const noscript = document.createElement("noscript");
    noscript.innerHTML = `<iframe src="${noscriptSrc}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.prepend(noscript);
  }
}

  if (appRegion === "BE") {
  const script = document.createElement("script");
  script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s);j.async=true;j.src="https://www.googletagmanager.com/gtm.js?id=${gtmId}";
    f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmId}');`;
  document.head.appendChild(script);
}
});
